// extracted by mini-css-extract-plugin
module.exports = {"card":"AqMyNsZTpH9V5d95Zu55","description":"LdvMj6Yg4u4MCC6gk0f0"};